import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, XCircle, ArrowRight } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { aboutContent } from '../data/mock';
import '../styles/pages.css';
import { soemLogo } from '../assets';
import usePageMeta from '../hooks/usePageMeta';

const About = () => {
  usePageMeta({
    title: 'Quiénes Somos',
    description: 'SOEM Partners Group surge de la necesidad de profesionalizar la seguridad en eventos masivos. Conozca nuestro origen, filosofía y equipo.',
    path: '/about',
  });

  return (
    <Layout>
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Quiénes Somos</h1>
          <p>Consultores especializados en seguridad estratégica para eventos</p>
        </div>
      </section>

      {/* History */}
      <section className="section">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <h2>Nuestra Historia</h2>
              <p className="lead-text">{aboutContent.history}</p>
              <p>
                A lo largo de los años, hemos desarrollado una metodología propia que integra 
                las mejores prácticas internacionales con el conocimiento profundo del contexto 
                local, permitiendo ofrecer soluciones de seguridad verdaderamente efectivas.
              </p>
            </div>
            <div className="content-image">
              <div className="image-box">
                <img 
                  src={soemLogo} 
                  alt="SOEM Partners Group"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Nuestra Filosofía</h2>
          </div>
          <div className="philosophy-box">
            <p className="philosophy-text">
              "{aboutContent.philosophy}"
            </p>
          </div>
        </div>
      </section>

      {/* What We Are / What We Are Not */}
      <section className="section">
        <div className="container">
          <div className="comparison-grid">
            <div className="comparison-card positive">
              <h3>
                <CheckCircle size={24} />
                Qué somos
              </h3>
              <ul>
                {aboutContent.whatWeAre.map((item, index) => (
                  <li key={index}>
                    <CheckCircle size={16} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="comparison-card negative">
              <h3>
                <XCircle size={24} />
                Qué NO somos
              </h3>
              <ul>
                {aboutContent.whatWeAreNot.map((item, index) => (
                  <li key={index}>
                    <XCircle size={16} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Experience */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Experiencia y Credenciales</h2>
          </div>
          <div className="experience-content">
            <p>
              Nuestro equipo está conformado por profesionales con amplia trayectoria en 
              gestión de riesgos, protección civil, coordinación operativa y seguridad corporativa.
            </p>
            <p>
              Hemos participado en la planeación y supervisión de seguridad para eventos de 
              diversa escala y naturaleza, desde reuniones ejecutivas de alto perfil hasta 
              eventos masivos con decenas de miles de asistentes.
            </p>
            <p>
              Nuestra experiencia abarca múltiples sectores: entretenimiento, deportes, 
              corporativo, gobierno, educación y cultura, lo que nos permite adaptar nuestras 
              metodologías a las necesidades específicas de cada cliente y evento.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Conozca nuestra metodología</h2>
            <p>
              Descubra cómo nuestro enfoque sistemático garantiza la seguridad 
              integral de su evento.
            </p>
            <Link to="/methodology" className="btn btn-primary">
              Ver metodología
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default About;
